<template>
  <b-container class="auth-page">
    <b-row class="justify-content-md-center">
      <b-col cols="12" xl="5" lg="6" md="8" sm="12">
        <div class="mt-4 b-form-1 basic-box-shadow">
          <h2>Reset della password</h2>
          <p>Richiedi un codice via email per cambiare la password.</p>
          <b-form @submit.prevent="passwordReset">
            <b-form-group label="Email:" label-for="usernameInput">
              <b-form-input
                id="usernameInput"
                type="text"
                v-model="username"
                required
                autofocus
                placeholder="La tua email"
              />
            </b-form-group>

            <b-button v-show="!submitting" type="submit" variant="primary">Invia codice</b-button>

            <b-button v-show="submitting" variant="primary" disabled>
              <b-spinner style="width: 1.4rem; height: 1.4rem;" label="Loading..."></b-spinner>
              <span class="sr-only">Loading...</span>
            </b-button>
          </b-form>
        </div>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center mt-3">
      <b-col cols="12" xl="5" lg="6" md="8" sm="12">
        <v-alert />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*
  With this form the user can reset his password
*/

import Vue from 'vue'

import { mapGetters } from 'vuex'
import router from '@/router'
import store from '@/store'

import Alert from '@/components/auth/Alert.vue'

Vue.component('v-alert', Alert)

export default {
  data () {
    return {
      username: '',
      submitting: false
    }
  },
  computed: {
    ...mapGetters('auth', ['hasAuthenticationStatus'])
  },
  methods: {
    async passwordReset () {
      this.submitting = true
      // call the authentication method for resetting the user's password
      await store.dispatch('auth/passwordReset', {
        username: this.username
      })
      this.submitting = false
      if (!this.hasAuthenticationStatus) {
        // route the user to the confirmation of the password reset
        router.push({ name: 'confirmPasswordReset' }).catch(err => console.error(err))
      }
    }
  }
}
</script>
